export { default as BultosSkim } from "./BultosSkim";
